module.exports = __webpack_public_path__ + "static/media/richa jii final-Model_page-0001.9cd7d111.jpg";